// Ô / nút dùng chung của các màn chưa đăng nhập (kiểu lg-* trong styles/login.css) — Quên / Đặt lại mật khẩu, Nhập mã,
// Nhận lời mời, Đổi mật khẩu bắt buộc. Màn Đăng nhập / Đăng ký có ô riêng (react-hook-form) cùng kiểu.

import { useState, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { AlertCircle, ChevronLeft, Eye, EyeOff, LockKeyhole } from 'lucide-react'
import { Spinner } from '@/components/ui/spinner'

/** Chỉ tự focus khi có chuột: trên máy cảm ứng bàn phím ảo bật lên che nửa màn hình ngay khi mở trang. */
export const finePointer = () => typeof window !== 'undefined' && window.matchMedia('(pointer: fine)').matches

export function AuthPassword({
  id, label, note, value, onChange, autoComplete = 'new-password', autoFocus, invalid, children,
}: {
  id: string
  label: string
  /** ràng buộc ngắn bên phải nhãn, vd "Tối thiểu 10 ký tự" */
  note?: string
  value: string
  onChange: (v: string) => void
  autoComplete?: string
  autoFocus?: boolean
  invalid?: boolean
  /** dưới ô: lỗi / tiêu chí mật khẩu */
  children?: ReactNode
}) {
  const [show, setShow] = useState(false)
  return (
    <div className="lg-field">
      <div className="lg-field-head">
        <label htmlFor={id}>{label}</label>
        {note && <span className="lg-note">{note}</span>}
      </div>
      <div className="lg-input-wrap">
        <LockKeyhole className="lg-input-icon" aria-hidden />
        <input
          id={id}
          type={show ? 'text' : 'password'}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className="lg-input has-eye"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={invalid || undefined}
        />
        <button type="button" onClick={() => setShow((v) => !v)} className="lg-eye" aria-label={show ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'} tabIndex={-1}>
          {show ? <EyeOff className="size-[18px]" /> : <Eye className="size-[18px]" />}
        </button>
      </div>
      {children}
    </div>
  )
}

export function AuthError({ children }: { children: ReactNode }) {
  return (
    <p className="lg-error" role="alert">
      <AlertCircle className="mt-px size-4 shrink-0" aria-hidden />
      <span>{children}</span>
    </p>
  )
}

export function AuthSubmit({ busy, busyLabel, disabled, children }: { busy: boolean; busyLabel: string; disabled?: boolean; children: ReactNode }) {
  return (
    <button type="submit" className="lg-btn" disabled={busy || disabled} data-busy={busy || undefined}>
      {busy ? <Spinner className="text-white" /> : null}
      {busy ? busyLabel : children}
    </button>
  )
}

/** Link quay lại ở đầu khung, vd "‹ Đăng nhập". */
export function AuthBack({ to, children, replace }: { to: string; children: ReactNode; replace?: boolean }) {
  return (
    <Link to={to} replace={replace} className="lg-back">
      <ChevronLeft className="size-[18px]" aria-hidden />
      {children}
    </Link>
  )
}
